module.exports = __webpack_public_path__ + "static/media/dsa.1ab691bc.jpg";